<template>
  <li :class="{
    'widget-in-use': inUse,
    'widget-disabled': disabled,
  }">
    <InputCheckbox :checked="inUse" :disabled="disabled" />

    <div class="widget-inner">
      <div class="widget-header">
        <div class="widget-title">
          {{ widget.name }}
          <IconPremium v-if="widget.isPremium" />
        </div>

        <div v-if="widget.isBenchmarking" class="widget-benchmarking">
          <IconCompare />
          <span>Benchmark Available</span>
        </div>
      </div>
      <div class="widget-description">{{ widget.description }}</div>

      <Button
        v-if="disabled && widget.previewImage"
        @click="onLearnMore(widget)"
        severity="tertiary"
      >
        Learn More
      </Button>
    </div>
  </li>
</template>

<script setup lang="ts">
import Button from '../global/Button.vue';
import InputCheckbox from '../inputs/InputCheckbox.vue';

import IconCompare from '@/icons/analytics/IconCompare.svg?component';
import IconPremium from '@/icons/IconPremium.svg?component';

import type { WidgetPreview } from '@/composables/useWidgets';

withDefaults(
  defineProps<{
    widget: WidgetPreview,
    inUse: boolean,
    disabled: boolean,
  }>(),
  {
    inUse: false,
    disabled: false,
  }
);

const emit = defineEmits(['onLearnMore']);

const onLearnMore = (widget: WidgetPreview) => {
  emit('onLearnMore', widget);
}
</script>
